import { Button } from 'antd';
import styled from 'styled-components';
import { blue01, blue02, blue } from '../../../styles/colors';

export const TagProductActionsButton = styled(Button)`
    margin-left: 5px;
    border-radius: 3px;
    background-color: ${blue01};
    color: #ffffff;
    cursor: pointer;
    border-color: ${blue01};
    border-radius: 3px 0 0 3px;
    &:focus {
        background-color: ${blue01};
        color: #ffff;
    }

    &:disabled {
        border-radius: 3px;
        border-color: ${blue01};
        color: #ffffff;
        background-color: ${blue01};
        opacity: 0.3;
    }

    &.add-selections-button {
        border-radius: 3px !important;
    }
`;

export const TagMenu = styled(Button)`
    border-radius: 0px 3px 3px 0;
    padding: 0 10px;
    background-color: ${blue01};
    border-color: ${blue01} ${blue01} ${blue01} rgba(255, 255, 255, 0.3);
    &:focus {
        background-color: ${blue};
        color: #ffff;
        border-color: #ffff;
    }
    &:disabled {
        border-radius: 3px;
        border-color: ${blue01};
        color: #ffffff;
        background-color: ${blue01};
        opacity: 0.3;
    }
`;

export const TagProductActionsButtonContainer = styled('div')`
    &:hover {
        button:first-child {
            background-color: ${blue02};
            color: #ffff;
        }
        button:last-child {
            background-color: ${blue02};
            color: #ffff;
        }
    }
`;